/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifacts_Add_Artifact_SuccessInputs */



/**
* | output |
* | --- |
* | "Artifact added successfully!" |
*
* @param {Artifacts_Add_Artifact_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_add_artifact_success = /** @type {((inputs?: Artifacts_Add_Artifact_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Add_Artifact_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Artefakt erfolgreich hinzugefügt!")
	return /** @type {LocalizedString} */ ("Artifact added successfully!")
});